export default class ForecastedMaintenanceGrowthCapex {
  /**
   *
   * @param {Number} forecastedRevenue
   * @param {Number} capexPercentageRevenue
   * @param {Number} capitalExpenditureAmount
   * @param {Number} growthRate
   * @param {Number} forecastedValue
   */
  constructor({
    forecastedRevenue = 0,
    capexPercentageRevenue= 0,
    growthRate = 1,
    analystNote = ""
  }) {
    this.forecastedRevenue = forecastedRevenue
    this.capexPercentageRevenue = capexPercentageRevenue
    this.growthRate = growthRate
    this.analystNote = analystNote
  }

  get capitalExpenditureAmount() {
    return this.forecastedRevenue * (this.capexPercentageRevenue / 100)
  }

  get forecastedAnnualCapex() {
    return this.capitalExpenditureAmount * this.growthRate
  }
}